export default __webpack_public_path__ + "static/media/Radio.7550e0d4.svg";